import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const CARDS = [
  {
    id: 1,
    num: "01",
    title: "HEALTHY RADIANCE",
    rotation: -5,
    className: "left-[0%] top-[24%] md:top-[26%]",
    img: "https://cdn.jiro.build/Natural%20Glow/Images/benefit%202.png",
  },
  {
    id: 2,
    num: "02",
    title: "DEEP HYDRATION",
    rotation: 3,
    className: "left-[24%] top-[6%] md:top-[8%]",
    img: "https://cdn.jiro.build/Natural%20Glow/Images/benefit%203.png",
  },
  {
    id: 3,
    num: "03",
    title: "SMOOTH TEXTURE",
    rotation: -3,
    className: "left-[48%] top-[24%] md:top-[26%]",
    img: "https://cdn.jiro.build/Natural%20Glow/Images/benefit%204.png",
  },
  {
    id: 4,
    num: "04",
    title: "LONG LASTING",
    rotation: 4,
    className: "left-[72%] top-[6%] md:top-[8%]",
    img: "https://cdn.jiro.build/Natural%20Glow/Images/Benefit%201.png",
  },
];

export default function BenefitsNatural({ className }) {
  const sectionRef = useRef(null);
  const headerRef = useRef(null);
  const cardsContainerRef = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const sectionEl = sectionRef.current;
    const headerEl = headerRef.current;
    const cardsContainerEl = cardsContainerRef.current;

    if (!sectionEl || !headerEl || !cardsContainerEl) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionEl,
        start: "top top",
        end: "+=300%",
        pin: true,
        scrub: 1.2,
        anticipatePin: 1,
        invalidateOnRefresh: true,
      },
    });

    tl.fromTo(
      headerEl,
      { x: "-70vw", opacity: 0 },
      { x: "0vw", opacity: 1, ease: "power2.out", duration: 1.2 },
      0
    );

    tl.fromTo(
      ".benefit-card",
      { x: "-85vw", opacity: 0, scale: 0.85 },
      {
        x: "0vw",
        opacity: 1,
        scale: 1,
        duration: 1.8,
        ease: "power2.out",
        stagger: 0.38,
      },
      0.5
    );

    tl.to(
      ".benefit-card",
      {
        x: "85vw",
        opacity: 0.1,
        ease: "power2.inOut",
        duration: 1.6,
        stagger: 0.35,
      },
      3.8
    );

    return () => {
      tl.scrollTrigger?.kill();
      tl.kill();
    };
  }, []);

  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link
        href="https://fonts.googleapis.com/css2?family=Big+Shoulders+Display:wght@400;700;800&display=swap"
        rel="stylesheet"
      />

      <section
        ref={sectionRef}
        className={"relative w-full h-screen bg-[#BCE26A] overflow-hidden flex flex-col justify-center items-center p-6 sm:p-10 md:p-16 select-none gap-4 " + (className || "")}
      >
        <div
          ref={headerRef}
          className="relative z-20 w-full max-w-[1520px] mx-auto flex flex-col items-center text-center pointer-events-auto shrink-0"
        >
          <h2
            className="tracking-tighter block leading-none text-center"
            style={{
              fontFamily: '"Big Shoulders Display", sans-serif',
              fontSize: "clamp(48px, 10vw, 160px)",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "1",
              letterSpacing: "-3px",
              margin: 0,
            }}
          >
            <span style={{ color: "#FFFFFF" }}>Benefits </span>
            <span style={{ color: "#000000" }}>Of Glow</span>
          </h2>
        </div>

        <div
          ref={cardsContainerRef}
          className="relative w-full max-w-[1170px] h-[480px] sm:h-[540px] md:h-[600px] lg:h-[640px] mx-auto z-10 flex items-center justify-center"
        >
          {CARDS.map((card) => (
            <div
              key={card.id}
              className={"benefit-card absolute w-[170px] h-[210px] sm:w-[230px] sm:h-[280px] md:w-[270px] md:h-[340px] lg:w-[290px] lg:h-[370px] bg-[#E2FF99] rounded-[8px] p-[14px] pb-[20px] flex flex-col gap-[14px] " + card.className}
              style={{
                transform: "rotate(" + card.rotation + "deg)",
              }}
            >
              <div className="w-full flex-1 min-h-0 rounded-[6px] overflow-hidden bg-[#E2FF99] flex items-center justify-center p-2">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover rounded-[4px]"
                  referrerPolicy="no-referrer"
                />
              </div>
              <div className="pt-0 pb-0">
                <h3
                  className="tracking-tight uppercase leading-none text-[#222222]"
                  style={{
                    fontFamily: '"Big Shoulders Display", sans-serif',
                    fontSize: "28px",
                    fontWeight: 800,
                    letterSpacing: "-0.5px",
                  }}
                >
                  {card.num} {card.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}